import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

export const NavbarContainer = styled("div")({
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  zIndex: 50,
  backgroundColor: "#252D2B",
});

export const Nav = styled("nav")({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",

  marginTop: "20px",
  marginBottom: "20px",
  marginLeft: "24px",
  marginRight: "24px",

  position: "relative",

  "@media (min-width: 1024px)": {
    marginTop: "32px",
    marginBottom: "32px",
    marginLeft: "128px",
    marginRight: "128px",
  },
});

export const Logo = styled("img")({
  width: "96px",
  marginRight: "auto",

  "@media (min-width: 1024px)": {
    width: "200px",
  },
});

export const DesktopMenu = styled("div")({
  display: "none",

  "@media (min-width: 1024px)": {
    display: "block",
  },
});

export const NavLinks = styled("div")({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "80px",
});

export const NavButton = styled(Button)({
  color: "#E9EDEC",
  fontFamily: "Manrope",
  fontSize: "18px",
  padding: "16px 0",
  fontWeight: "bold",
  textTransform: "none",

  "&:hover": {
    color: "#68D75A",
    backgroundColor: "transparent",
  },
});

export const LoginButton = styled(Button)({
  color: "#E9EDEC",
  border: "1px solid #d8c9c0",
  padding: "16px 24px",
  fontSize: "18px",
  lineHeight: 1.5,
  textTransform: "none",
  fontFamily: "Manrope",
  fontWeight: "bold",

  "&:hover": {
    backgroundColor: "#68D75A",
    color: "#252D2B",
  },
});

export const DesktopNavItem = styled("div")({
  position: "relative",
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
  "&:hover .desktop-dropdown": {
    opacity: 1,
    visibility: "visible",
    pointerEvents: "auto",
  },
});

export const DesktopDropdown = styled("div")({
  position: "absolute",
  top: "100%",
  left: "50%",
  transform: "translateX(-50%)",
  width: "600px",
  boxSizing: "border-box",
  paddingTop: "20px",
  backgroundColor: "transparent",
  zIndex: 40,
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  opacity: 0,
  visibility: "hidden",
  pointerEvents: "none",
  transition: "opacity 0.2s ease, visibility 0.2s ease",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: "20px",
  },
  "&::after": {
    content: '""',
    position: "absolute",
    top: "20px",
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "#161B1A",
    zIndex: -1,
  },
});

export const DesktopDropdownItem = styled("a")({
  width: "100%",
  boxSizing: "border-box",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "12px 20px",
  color: "white",
  fontFamily: "Manrope",
  fontSize: "18px",
  fontWeight: "bold",
  textDecoration: "none",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: "#000000",
    color: "#68D75A",
    borderLeft: "6px solid #68D75A"
  },
});

export const MobileMenuContainer = styled("div")({
  display: "block",

  "@media (min-width: 1024px)": {
    display: "none",
  },
});

export const MobileMenuButton = styled(Button)({
  color: "#d8c9c0",
  fontSize: "36px",
  minWidth: "auto",
  padding: 0,
  position: "relative",
  zIndex: 50,
  "&:hover": {
    backgroundColor: "transparent",
    color: "#68D75A",
  },
});

export const MobileMenuPanel = styled("div")({
  position: "fixed",
  top: "96px",
  left: "20px",
  width: "calc(100% - 40px)",
  boxSizing: "border-box",
  backgroundColor: "#161B1A",
  zIndex: 40,
  "@media (min-width: 481px) and (max-width: 1023px)": {
    top: "90px",
  },
});

export const MobileNavLinks = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  gap: "4px",
  width: "100%",
});

export const MobileNavItem = styled("div")({
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 0,
  cursor: "pointer",
  "&:hover": {
    backgroundColor: "#000000",
  },
  "&:hover button": {
    color: "#68D75A",
    backgroundColor: "transparent",
    borderLeft: "6px solid #68D75A",
  },
});

export const MobileNavButton = styled(Button)({
  width: "100%",
  color: "white",
  fontFamily: "Manrope",
  fontSize: "16px",
  fontWeight: "bold",
  textTransform: "none",
  padding: "12px 0",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "transparent",
  "&:hover": {
    backgroundColor: "transparent",
  },
});